import React from "react";
import { createSvgIcon } from "../create-svg-icon";

export const SignalCellular1BarIcon = createSvgIcon(
  <React.Fragment>
    <path fillOpacity=".3" d="M2 22h20V2L2 22z" />
    <path d="M12 12L2 22h10V12z" />
  </React.Fragment>,
  "SignalCellular1BarOutlined"
);
